import getActionsByDocument from '../../../../../../../components/comments/actions';

const DOCUMENT = 'SESSION_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
